import { Component, OnInit, Input, TemplateRef, ContentChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import {RcEventBusService} from '../rc-utils/rc-event-bus/rc-event-bus.service';
import {RcAuthService} from '../rc-utils/rc-auth/rc-auth.service';

@Component({
  selector: 'lib-rc-login',
  template: `<div class="{{dir}}">
  <div class="rc-login">

    <div class="title">
      <h2>{{titleText}}</h2>
    </div>

    <div ng-if="note !== ''">
      <div class="note">
        <span>{{note}}</span>
      </div>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-login">
      <div class="form-group" *ngIf="!isOtpSent">
        <lib-rc-input [label]="'username'" [control]="username" [elementId]="'Username'" [errorMsg]="getControlError('username')"
          class="lib-rc-input">
        </lib-rc-input>
      </div>

      <div class="form-group" *ngIf="usePassword && !isOtpSent">
        <lib-rc-input [label]="'Password'" [type]="'password'" [control]="password" [elementId]="'Password'" [errorMsg]="getControlError('password')"
          class="lib-rc-input">
        </lib-rc-input>
      </div>

      <lib-rc-otp *ngIf="useOtp" [recaptchaResponse]="recaptchaResponse" [username]="username.value" [resend]="resend"></lib-rc-otp>

      <lib-rc-recaptcha *ngIf="!isOtpSent" (resolved)="onRecaptchaResolved($event)" class="lib-rc-recaptcha"></lib-rc-recaptcha>

        <div class="spinner-loader" *ngIf="showLoader">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
        </div>

      <ng-container *ngTemplateOutlet="errorsTemplate">

      </ng-container>


      <div class="submit-btn">
        <button [disabled]="!isOtpSent && !recaptchaResponse" class="btn btn-primary" type="submit">{{submitBtnText}}</button>
      </div>

    </form>

  </div>
</div>
`,
  styles: [`.ltr{direction:ltr}.ltr .rc-login{height:420px;width:477px;border:1px solid #daeffe;border-radius:4px;background-color:#fff;box-shadow:0 18px 29px 0 rgba(26,48,64,.2);display:block;margin:98px auto}.ltr .rc-login .lib-rc-recaptcha{margin-left:16px;display:block}.ltr .rc-login .title{height:44px;width:134px;color:#1a3040;font-family:Helvetica;font-size:37px;font-weight:300;line-height:44px;margin:28px 328px 16px 15px}.ltr .rc-login .note{height:16px;width:33px;color:#586d7d;font-family:Helvetica;font-size:13px;font-weight:300;line-height:16px;margin:16px 428px 16px 15px}.ltr .rc-login .small-title{height:16px;width:65px;color:#1a3040;font-family:Helvetica;font-size:14px;line-height:16px}.ltr .rc-login .lib-rc-input .form-group{margin-left:15px}.ltr .rc-login .submit-btn button{height:48px;color:#fff;width:145px;border-radius:24px;background-color:#008fff;box-shadow:inset -1px 1px 1px 0 rgba(255,255,255,.5),0 9px 13px 0 rgba(0,0,0,.23);margin:28px 166px 60px}.rtl{direction:rtl}.rtl .rc-login{height:420px;width:477px;border:1px solid #daeffe;border-radius:4px;background-color:#fff;box-shadow:0 18px 29px 0 rgba(26,48,64,.2);display:block;margin:98px auto;direction:rtl;text-align:right}.rtl .rc-login .lib-rc-recaptcha{margin-left:16px;display:block}.rtl .rc-login .title{height:44px;color:#1a3040;font-family:Helvetica;font-size:37px;font-weight:300;line-height:44px;margin:28px 15px 16px 328px}.rtl .rc-login .note{height:16px;width:100%;color:#586d7d;font-family:Helvetica;font-size:13px;font-weight:300;line-height:16px;margin:16px 15px 16px 428px}.rtl .rc-login .small-title{height:16px;width:65px;color:#1a3040;font-family:Helvetica;font-size:14px;line-height:16px}.rtl .rc-login .lib-rc-input .form-group{margin-right:15px}.rtl .rc-login .submit-btn button{height:48px;width:145px;color:#fff;border-radius:24px;background-color:#008fff;box-shadow:inset -1px 1px 1px 0 rgba(255,255,255,.5),0 9px 13px 0 rgba(0,0,0,.23);margin:28px 166px 60px}.spinner-loader{width:64px;height:64px;position:absolute;left:48%;top:38%}.spinner-loader .lds-ellipsis{display:inline-block;position:relative;width:64px;height:64px}.spinner-loader .lds-ellipsis div{position:absolute;top:27px;width:11px;height:11px;border-radius:50%;background:#008fff;-webkit-animation-timing-function:cubic-bezier(0,1,1,0);animation-timing-function:cubic-bezier(0,1,1,0)}.spinner-loader .lds-ellipsis div:nth-child(1){left:6px;-webkit-animation:.6s infinite lds-ellipsis1;animation:.6s infinite lds-ellipsis1}.spinner-loader .lds-ellipsis div:nth-child(2){left:6px;-webkit-animation:.6s infinite lds-ellipsis2;animation:.6s infinite lds-ellipsis2}.spinner-loader .lds-ellipsis div:nth-child(3){left:26px;-webkit-animation:.6s infinite lds-ellipsis2;animation:.6s infinite lds-ellipsis2}.spinner-loader .lds-ellipsis div:nth-child(4){left:45px;-webkit-animation:.6s infinite lds-ellipsis3;animation:.6s infinite lds-ellipsis3}@-webkit-keyframes lds-ellipsis1{0%{-webkit-transform:scale(0);transform:scale(0)}100%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes lds-ellipsis1{0%{-webkit-transform:scale(0);transform:scale(0)}100%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes lds-ellipsis3{0%{-webkit-transform:scale(1);transform:scale(1)}100%{-webkit-transform:scale(0);transform:scale(0)}}@keyframes lds-ellipsis3{0%{-webkit-transform:scale(1);transform:scale(1)}100%{-webkit-transform:scale(0);transform:scale(0)}}@-webkit-keyframes lds-ellipsis2{0%{-webkit-transform:translate(0,0);transform:translate(0,0)}100%{-webkit-transform:translate(19px,0);transform:translate(19px,0)}}@keyframes lds-ellipsis2{0%{-webkit-transform:translate(0,0);transform:translate(0,0)}100%{-webkit-transform:translate(19px,0);transform:translate(19px,0)}}`]
})
export class RcLoginComponent implements OnInit {

  @Input() returnUrl: string;
  @Input() usePassword = true;
  @Input() useOtp = false;
  @Input() submitBtnText = 'submit';
  @Input() titleText = 'Login';
  @Input() dir = 'ltr';
  @Input() note = '';
  @Input() resend = 'Resend';
  @ContentChild(TemplateRef) errorsTemplate: TemplateRef<any>;

  submitted = false;

  loginForm: FormGroup;
  username: FormControl;
  password: FormControl;
  recaptchaResponse: string;
  errors = [];
  isOtpSent = false;
  showLoader = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventBusService: RcEventBusService,
    private authenticationService: RcAuthService) {
    this.username = new FormControl('', [Validators.required]);
    this.password = new FormControl('', []);
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      username: this.username,
      password: this.password
    });

    // reset login status
    this.authenticationService.logout();

    // get return url from input or route parameters or default to '/'
    this.returnUrl = this.returnUrl || this.route.snapshot.queryParams['returnUrl'] || '/';

    // catch otp sent event
    this.eventBusService.on('OTP_SENT_SUCCESS', (claims) => {
      this.isOtpSent = true;
      this.showLoader = false;
    });




    // catch otp sent event
    this.eventBusService.on('OTP_SUCCEEDED', (claims) => {
      this.showLoader = false;
    });

    this.eventBusService.on('SEND_OTP_ERROR', (claims) => {
      this.showLoader = false;
    });

    this.eventBusService.on('CONFIRM_OTP_ERROR', (claims) => {
      this.showLoader = false;
    });

  }

  getControlError(controlName) {
    return this.submitted && this.loginForm.controls[controlName].errors ? controlName + ' is required' : '';
  }
  onRecaptchaResolved(event: any) {
    this.recaptchaResponse = event;
  }
  onSubmit() {
    this.errors = [];
    this.submitted = true;
    this.showLoader = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.showLoader = false;
      return;
    }
    if (this.useOtp) {
      this.eventBusService.emit('USE_OTP');
    }
    if (this.usePassword) {
      this.authenticationService.login(this.loginForm.controls.username.value,
        this.loginForm.controls.password.value,
        this.recaptchaResponse)
        .pipe(first())
        .subscribe(() => {
          this.router.navigate([this.returnUrl]);
          this.showLoader = false;
        },
          e => {
            this.errors = e;
            this.showLoader = false;
          });
    }
  }

}
